(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CaptchaHandler", [], factory);
	else if(typeof exports === 'object')
		exports["CaptchaHandler"] = factory();
	else
		root["CaptchaHandler"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	
	Object.defineProperty(exports, "__esModule", { value: true });
	var captcha_handler_1 = __webpack_require__(1);
	var gee_test_reject_error_1 = __webpack_require__(11);
	exports.GeeTestRejectError = gee_test_reject_error_1["default"];
	var src_1 = __webpack_require__(2);
	exports.VerifyRejectState = src_1.VerifyRejectState;
	var version = ("1.1.0");
	exports.version = version;
	exports["default"] = captcha_handler_1["default"];
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2);
	var geetest_captcha_model_1 = __webpack_require__(5);
	var picture_captcha_model_1 = __webpack_require__(7);
	var abstract_captcha_model_1 = __webpack_require__(6);
	var gee_test_reject_error_1 = __webpack_require__(11);

	var CaptchaHandler = function () {
	    function CaptchaHandler() {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref$geeTestSettings = _ref.geeTestSettings,
	            geeTestSettings = _ref$geeTestSettings === undefined ? {} : _ref$geeTestSettings,
	            _ref$pictureSettings = _ref.pictureSettings,
	            pictureSettings = _ref$pictureSettings === undefined ? {} : _ref$pictureSettings;

	        _classCallCheck(this, CaptchaHandler);

	        this.geeTestSettings = geeTestSettings;
	        this.pictureSettings = pictureSettings;
	    }

	    CaptchaHandler.decorate = function decorate(params) {
	        var intercept = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (f) {
	            return f;
	        };

	        /**
	         * overload
	         */
	        if (typeof params === 'function') {
	            intercept = params;
	            params = undefined;
	        }
	        var captchaHandler = new CaptchaHandler(params);
	        var Mode = void 0;
	        (function (Mode) {
	            Mode[Mode["MethodDecorate"] = 1] = "MethodDecorate";
	            Mode[Mode["ES5Function"] = 2] = "ES5Function";
	        })(Mode || (Mode = {}));
	        return function (target, name) {
	            var descriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var mode = void 0;
	            if (target && name && descriptor) {
	                mode = 1 /* MethodDecorate */;
	            } else if (typeof target === 'function') {
	                mode = 2 /* ES5Function */;
	                descriptor.value = target;
	            }
	            var submit = descriptor.value;
	            descriptor.value = function () {
	                var $args = arguments;return new Promise(function ($return, $error) {
	                    var _ref2, state, data, _len, args, _key, newArgs;

	                    return Promise.resolve(captchaHandler.verify()).then(function ($await_2) {
	                        try {
	                            _ref2 = $await_2, state = _ref2.state, data = _ref2.data;

	                            if (state === index_1.VerifyRejectState.Success) {
	                                /**
	                                 * 由于极验reset并不会发起请求, 拿到凭证后可直接重置captchaHandler即可
	                                 * 放置在submit.apply前面也能防止后续异常导致没有正确重置
	                                 */
	                                captchaHandler.reset();

	                                for (_len = $args.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                                    args[_key] = $args[_key];
	                                }

	                                newArgs = intercept(args, data);
	                                if (Object.prototype.toString.call(newArgs) === '[object Array]') {
	                                    return $return(submit.apply(this, intercept(newArgs)));
	                                }
	                                return $error(new Error('<intercept> 函数必须返回数组类型'));
	                            } else if (state === index_1.VerifyRejectState.Cancel) {
	                                return $return(Promise.resolve(new gee_test_reject_error_1["default"](state, data)));
	                            }
	                            return $return(Promise.reject(new gee_test_reject_error_1["default"](state, data)));
	                        } catch ($boundEx) {
	                            return $error($boundEx);
	                        }
	                    }.bind(this), $error);
	                }.bind(this));
	            };
	            if (mode === 1 /* MethodDecorate */) {
	                    return descriptor;
	                } else if (mode === 2 /* ES5Function */) {
	                    return descriptor.value;
	                } else {
	                throw new Error('unexpected condition. please contact the author');
	            }
	        };
	    };

	    CaptchaHandler.prototype.init = function init() {
	        return new Promise(function ($return, $error) {
	            var pictureSettings, geeTestSettings, geeTestCaptchaObject;

	            if (this.captchaModel) {
	                /**
	                 * 当前为图片验证码时候且状态不为reset
	                 */
	                if (this.captchaModel instanceof picture_captcha_model_1["default"] && this.captchaModel.getState() !== abstract_captcha_model_1.CaptchaModelStateEnum.Reset) {
	                    return $return();
	                }
	                if (this.captchaModel instanceof geetest_captcha_model_1["default"]) {
	                    return $return();
	                }
	            }
	            pictureSettings = this.pictureSettings, geeTestSettings = this.geeTestSettings;

	            /**
	             * 预处理极验配置项
	             */
	            CaptchaHandler.preProcessGeetestSettings(geeTestSettings);
	            var $Try_1_Post = function () {
	                try {
	                    return $return();
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this);var $Try_1_Catch = function (e) {
	                try {
	                    if (e instanceof Error) {
	                        throw e;
	                    }
	                    this.captchaModel = new picture_captcha_model_1["default"](pictureSettings);
	                    return $Try_1_Post();
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this);try {
	                return Promise.resolve(index_1["default"].authAndInit(geeTestSettings)).then(function ($await_3) {
	                    try {
	                        geeTestCaptchaObject = $await_3;
	                        this.captchaModel = new geetest_captcha_model_1["default"](geeTestCaptchaObject);
	                        return $Try_1_Post();
	                    } catch ($boundEx) {
	                        return $Try_1_Catch($boundEx);
	                    }
	                }.bind(this), $Try_1_Catch);
	            } catch (e) {
	                $Try_1_Catch(e)
	            }
	        }.bind(this));
	    };

	    CaptchaHandler.preProcessGeetestSettings = function preProcessGeetestSettings() {
	        var geeTestSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	        var geeTestOptions = geeTestSettings.options = geeTestSettings.options || {};
	        if (!geeTestOptions.product) {
	            geeTestOptions.product = 'bind';
	        }
	        if (geeTestOptions.product && geeTestOptions.product !== 'bind') {
	            throw new Error('captcha handler 仅支持极验为 {product: \'bind\'} 的模式');
	        }
	    };

	    CaptchaHandler.prototype.verify = function verify() {
	        return new Promise(function ($return, $error) {
	            return Promise.resolve(this.init()).then(function ($await_4) {
	                try {
	                    return $return(this.captchaModel.verify());
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this), $error);
	        }.bind(this));
	    };

	    CaptchaHandler.prototype.reset = function reset() {
	        this.captchaModel.reset();
	    };

	    return CaptchaHandler;
	}();

	exports["default"] = CaptchaHandler;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", { value: true });
	var _init = __webpack_require__(3);
	var pre_auth_1 = __webpack_require__(4);
	/**
	 * 极验/图形验证码校验失败的状态
	 */
	var VerifyRejectState;
	(function (VerifyRejectState) {
	    VerifyRejectState[VerifyRejectState["Cancel"] = 0] = "Cancel";
	    VerifyRejectState[VerifyRejectState["Error"] = -1] = "Error";
	    VerifyRejectState[VerifyRejectState["Success"] = 1] = "Success";
	})(VerifyRejectState = exports.VerifyRejectState || (exports.VerifyRejectState = {}));

	var WebGeeTest = function () {
	    function WebGeeTest() {
	        _classCallCheck(this, WebGeeTest);
	    }

	    WebGeeTest.authAndInit = function authAndInit(preAuthParams) {
	        return pre_auth_1["default"](preAuthParams);
	    };

	    WebGeeTest.init = function init(settings) {
	        /**
	         * 重置为 100%， 让父类去控制
	         */
	        settings.width = settings.width || '100%';
	        return new Promise(function (resolve) {
	            _init(settings, function (captchaObj) {
	                captchaObj.onReady(function () {
	                    return resolve(captchaObj);
	                });
	            });
	        });
	    };

	    WebGeeTest.verify = function verify(captchaObj) {
	        return new Promise(function (resolve, reject) {
	            captchaObj.onSuccess(function () {
	                var validation = captchaObj.getValidate();
	                resolve({ state: VerifyRejectState.Success, data: validation });
	            });
	            captchaObj.onClose(function () {
	                resolve({ state: VerifyRejectState.Cancel });
	            });
	            captchaObj.onError(function () {
	                reject({ state: VerifyRejectState.Error, message: '出错啦，请稍后重试' });
	            });
	            captchaObj.verify();
	        });
	    };

	    WebGeeTest.reset = function reset(captchaObj) {
	        captchaObj.reset();
	    };

	    return WebGeeTest;
	}();

	exports["default"] = WebGeeTest;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/* initGeetest 1.0.0
	 * 用于加载id对应的验证码库，并支持宕机模式
	 * 暴露 initGeetest 进行验证码的初始化
	 * 一般不需要用户进行修改
	 */
	(function(global, factory) {
	    "use strict";
	    if (typeof module === "object" && typeof module.exports === "object") {
	        // CommonJS
	        module.exports = global.document ?
	            factory(global, true) :
	            function(w) {
	                if (!w.document) {
	                    throw new Error("Geetest requires a window with a document");
	                }
	                return factory(w);
	            };
	    } else {
	        factory(global);
	    }
	})(typeof window !== "undefined" ? window : this, function(window, noGlobal) {
	    "use strict";
	    if (typeof window === 'undefined') {
	        throw new Error('Geetest requires browser environment');
	    }
	    var document = window.document;
	    var Math = window.Math;
	    var head = document.getElementsByTagName("head")[0];
	    function _Object(obj) {
	        this._obj = obj;
	    }
	    _Object.prototype = {
	        _each: function(process) {
	            var _obj = this._obj;
	            for (var k in _obj) {
	                if (_obj.hasOwnProperty(k)) {
	                    process(k, _obj[k]);
	                }
	            }
	            return this;
	        }
	    };
	    function Config(config) {
	        var self = this;
	        new _Object(config)._each(function(key, value) {
	            self[key] = value;
	        });
	    }
	    Config.prototype = {
	        api_server: 'api.geetest.com',
	        protocol: 'http://',
	        type_path: '/gettype.php',
	        fallback_config: {
	            slide: {
	                static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
	                type: 'slide',
	                slide: '/static/js/geetest.0.0.0.js'
	            },
	            fullpage: {
	                static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
	                type: 'fullpage',
	                fullpage: '/static/js/fullpage.0.0.0.js'
	            }
	        },
	        _get_fallback_config: function() {
	            var self = this;
	            if (isString(self.type)) {
	                return self.fallback_config[self.type];
	            } else if (self.new_captcha) {
	                return self.fallback_config.fullpage;
	            } else {
	                return self.fallback_config.slide;
	            }
	        },
	        _extend: function(obj) {
	            var self = this;
	            new _Object(obj)._each(function(key, value) {
	                self[key] = value;
	            })
	        }
	    };
	    var isNumber = function(value) {
	        return (typeof value === 'number');
	    };
	    var isString = function(value) {
	        return (typeof value === 'string');
	    };
	    var isBoolean = function(value) {
	        return (typeof value === 'boolean');
	    };
	    var isObject = function(value) {
	        return (typeof value === 'object' && value !== null);
	    };
	    var isFunction = function(value) {
	        return (typeof value === 'function');
	    };
	    var callbacks = {};
	    var status = {};
	    var random = function() {
	        return parseInt(Math.random() * 10000) + (new Date()).valueOf();
	    };
	    var loadScript = function(url, cb) {
	        var script = document.createElement("script");
	        script.charset = "UTF-8";
	        script.async = true;
	        script.onerror = function() {
	            cb(true);
	        };
	        var loaded = false;
	        script.onload = script.onreadystatechange = function() {
	            if (!loaded &&
	                (!script.readyState ||
	                    "loaded" === script.readyState ||
	                    "complete" === script.readyState)) {
	                loaded = true;
	                setTimeout(function() {
	                    cb(false);
	                }, 0);
	            }
	        };
	        script.src = url;
	        head.appendChild(script);
	    };
	    var normalizeDomain = function(domain) {
	        return domain.replace(/^https?:\/\/|\/$/g, '');
	    };
	    var normalizePath = function(path) {
	        path = path.replace(/\/+/g, '/');
	        if (path.indexOf('/') !== 0) {
	            path = '/' + path;
	        }
	        return path;
	    };
	    var normalizeQuery = function(query) {
	        if (!query) {
	            return '';
	        }
	        var q = '?';
	        new _Object(query)._each(function(key, value) {
	            if (isString(value) || isNumber(value) || isBoolean(value)) {
	                q = q + encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
	            }
	        });
	        if (q === '?') {
	            q = '';
	        }
	        return q.replace(/&$/, '');
	    };
	    var makeURL = function(protocol, domain, path, query) {
	        domain = normalizeDomain(domain);
	        var url = normalizePath(path) + normalizeQuery(query);
	        if (domain) {
	            url = protocol + domain + url;
	        }
	        return url;
	    };
	    var load = function(protocol, domains, path, query, cb) {
	        var tryRequest = function(at) {
	            var url = makeURL(protocol, domains[at], path, query);
	            loadScript(url, function(err) {
	                if (err) {
	                    if (at >= domains.length - 1) {
	                        cb(true);
	                    } else {
	                        tryRequest(at + 1);
	                    }
	                } else {
	                    cb(false);
	                }
	            });
	        };
	        tryRequest(0);
	    };
	    var jsonp = function(domains, path, config, callback) {
	        if (isObject(config.getLib)) {
	            config._extend(config.getLib);
	            callback(config);
	            return;
	        }
	        if (config.offline) {
	            callback(config._get_fallback_config());
	            return;
	        }
	        var cb = "geetest_" + random();
	        window[cb] = function(data) {
	            if (data.status === 'success') {
	                callback(data.data);
	            } else if (!data.status) {
	                callback(data);
	            } else {
	                callback(config._get_fallback_config());
	            }
	            window[cb] = undefined;
	            try {
	                delete window[cb];
	            } catch (e) {}
	        };
	        load(config.protocol, domains, path, {
	            gt: config.gt,
	            callback: cb
	        }, function(err) {
	            if (err) {
	                callback(config._get_fallback_config());
	            }
	        });
	    };
	    var throwError = function(errorType, config) {
	        var errors = {
	            networkError: '网络错误'
	        };
	        if (typeof config.onError === 'function') {
	            config.onError(errors[errorType]);
	        } else {
	            throw new Error(errors[errorType]);
	        }
	    };
	    var detect = function() {
	        return !!window.Geetest;
	    };
	    if (detect()) {
	        status.slide = "loaded";
	    }
	    var initGeetest = function(userConfig, callback) {
	        var config = new Config(userConfig);
	        if (userConfig.https) {
	            config.protocol = 'https://';
	        } else if (!userConfig.protocol) {
	            config.protocol = window.location.protocol + '//';
	        }
	        jsonp([config.api_server || config.apiserver], config.type_path, config, function(newConfig) {
	            var type = newConfig.type;
	            var init = function() {
	                config._extend(newConfig);
	                callback(new window.Geetest(config));
	            };
	            callbacks[type] = callbacks[type] || [];
	            var s = status[type] || 'init';
	            if (s === 'init') {
	                status[type] = 'loading';
	                callbacks[type].push(init);
	                load(config.protocol, newConfig.static_servers || newConfig.domains, newConfig[type] || newConfig.path, null, function(err) {
	                    if (err) {
	                        status[type] = 'fail';
	                        throwError('networkError', config);
	                    } else {
	                        status[type] = 'loaded';
	                        var cbs = callbacks[type];
	                        for (var i = 0, len = cbs.length; i < len; i = i + 1) {
	                            var cb = cbs[i];
	                            if (isFunction(cb)) {
	                                cb();
	                            }
	                        }
	                        callbacks[type] = [];
	                    }
	                });
	            } else if (s === "loaded") {
	                init();
	            } else if (s === "fail") {
	                throwError('networkError', config);
	            } else if (s === "loading") {
	                callbacks[type].push(init);
	            }
	        });
	    };
	    window.initGeetest = initGeetest;
	    return initGeetest;
	});


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2);
	/**
	 * 验证码模式
	 */
	var CaptchaMode;
	(function (CaptchaMode) {
	    CaptchaMode[CaptchaMode["Picture"] = 1] = "Picture";
	    CaptchaMode[CaptchaMode["GeeTest"] = 2] = "GeeTest";
	})(CaptchaMode || (CaptchaMode = {}));
	/**
	 * 默认pre auth请求地址
	 */
	var defaultPreAuthUrls = {
	    http: 'http://apps-ws.xoyo.com/passport/pre_auth',
	    https: 'https://apps-ws.xoyo.com/passport/pre_auth'
	};
	function getNormalizeProtocol() {
	    return window.location.protocol.slice(0, -1).toLowerCase();
	}
	/**
	 * 获取默认url地址
	 * @returns {string} - 正确返回请求地址
	 */
	function getDefaultUrl() {
	    var preAuthUrl = defaultPreAuthUrls[getNormalizeProtocol()];
	    if (!preAuthUrl) {
	        throw new Error('若使用默认url地址时，请确保浏览器 url protocol 为 http 或 https');
	    }
	    return preAuthUrl;
	}
	/**
	 * 校验请求是否是xfe-request
	 * @param request
	 */
	function invariantRequest(request) {
	    if (!request.jsonp) {
	        throw new Error('请使用xfe-request完成以下操作');
	    }
	}
	/**
	 *
	 * @param {Object} params - 请求参数
	 * @param {{jsonp: ((url: string, params: Object) => Promise<IPreAuthResponse>)}} request - 请求实现， 默认使用 xfe-request
	 * @param {string} url - 请求地址，默认使用内部配置地址
	 * @param {IInitSettings} options - 极验配置项
	 * @param {(url: string, params: Object) => Promise<IPreAuthResponse>} requestImpl
	 * @returns {Promise<any>}
	 */
	function preAuth(_ref) {
	    return new Promise(function ($return, $error) {
	        var params, request, _ref$url, url, options, requestImpl, requestPreAuthImpl, response, _response, _response$data, mode, config, code, state;

	        params = _ref.params, request = _ref.request, _ref$url = _ref.url, url = _ref$url === undefined ? getDefaultUrl() : _ref$url, options = _ref.options, requestImpl = _ref.requestImpl, requestPreAuthImpl = _ref.requestPreAuthImpl;

	        request && invariantRequest(request);
	        /**
	         * requestPreAuthImpl 作为别名, 也为了兼容
	         */
	        if (requestPreAuthImpl) {
	            requestImpl = requestPreAuthImpl;
	        }
	        if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === 'object') {
	            url = url[getNormalizeProtocol()];
	        }
	        response = void 0;
	        if (request) {
	            return Promise.resolve(request.jsonp(url, params)).then(function ($await_3) {
	                try {
	                    response = $await_3;
	                    return $If_1.call(this);
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this), $error);
	        } else {
	            if (requestImpl) {
	                return Promise.resolve(requestImpl(url, params)).then(function ($await_4) {
	                    try {
	                        response = $await_4;
	                        return $If_2.call(this);
	                    } catch ($boundEx) {
	                        return $error($boundEx);
	                    }
	                }.bind(this), $error);
	            } else {
	                return $error(new Error('请传入 request 或 requestImpl'));
	            }

	            function $If_2() {
	                return $If_1.call(this);
	            }

	            return $If_2.call(this);
	        }
	        function $If_1() {
	            _response = response, _response$data = _response.data, mode = _response$data.mode, config = _response$data.config, code = _response.code, state = _response.state;

	            /**
	             * code 和 state 表达一样的含义, 当 state 出现时, 为了兼容旧系统, state 直接赋值给 code
	             */
	            if (state) {
	                code = state;
	            }
	            if (code === 1 /*成功*/) {
	                    if (mode === 2 /* GeeTest */) {
	                            return $return(index_1["default"].init(_extends({}, config, options)));
	                        } else if (mode === 1 /* Picture */) {
	                            return $return(Promise.reject(response));
	                        } else {
	                        return $error(new Error("\u672A\u77E5 pre auth mode\uFF0Cmode = " + mode));
	                    }
	                }
	            return $return(Promise.reject(response));
	        }
	    }.bind(this));
	}
	exports["default"] = preAuth;
	//# sourceMappingURL=pre-auth.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(2);
	var abstract_captcha_model_1 = __webpack_require__(6);

	var GeetestCaptchaModel = function (_abstract_captcha_mod) {
	    _inherits(GeetestCaptchaModel, _abstract_captcha_mod);

	    function GeetestCaptchaModel(captchaObj) {
	        _classCallCheck(this, GeetestCaptchaModel);

	        var _this = _possibleConstructorReturn(this, _abstract_captcha_mod.call(this));

	        _this.captchaObj = captchaObj;
	        return _this;
	    }

	    GeetestCaptchaModel.prototype.verifyProcess = function verifyProcess() {
	        return new Promise(function ($return, $error) {
	            return $return(index_1["default"].verify(this.captchaObj));
	        }.bind(this));
	    };

	    GeetestCaptchaModel.prototype.resetProcess = function resetProcess() {
	        this.captchaObj.reset();
	    };

	    return GeetestCaptchaModel;
	}(abstract_captcha_model_1["default"]);

	exports["default"] = GeetestCaptchaModel;
	//# sourceMappingURL=geetest-captcha-model.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", { value: true });
	var CaptchaModelStateEnum;
	(function (CaptchaModelStateEnum) {
	    CaptchaModelStateEnum[CaptchaModelStateEnum["Initialized"] = 1] = "Initialized";
	    CaptchaModelStateEnum[CaptchaModelStateEnum["Reset"] = -1] = "Reset";
	    CaptchaModelStateEnum[CaptchaModelStateEnum["Verified"] = 2] = "Verified";
	})(CaptchaModelStateEnum = exports.CaptchaModelStateEnum || (exports.CaptchaModelStateEnum = {}));

	var AbstractCaptchaModel = function () {
	    function AbstractCaptchaModel() {
	        _classCallCheck(this, AbstractCaptchaModel);

	        this.setState(CaptchaModelStateEnum.Initialized);
	    }

	    AbstractCaptchaModel.prototype.setState = function setState(state) {
	        this.state = state;
	    };

	    AbstractCaptchaModel.prototype.getState = function getState() {
	        return this.state;
	    };

	    AbstractCaptchaModel.prototype.verify = function verify() {
	        return new Promise(function ($return, $error) {
	            var result;
	            return Promise.resolve(this.verifyProcess()).then(function ($await_1) {
	                try {
	                    result = $await_1;
	                    this.setState(CaptchaModelStateEnum.Verified);
	                    return $return(result);
	                } catch ($boundEx) {
	                    return $error($boundEx);
	                }
	            }.bind(this), $error);
	        }.bind(this));
	    };

	    AbstractCaptchaModel.prototype.reset = function reset() {
	        this.resetProcess();
	        this.setState(CaptchaModelStateEnum.Reset);
	    };

	    return AbstractCaptchaModel;
	}();

	exports["default"] = AbstractCaptchaModel;
	//# sourceMappingURL=abstract-captcha-model.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable prefer-arrow-callback */
	var index_1 = __webpack_require__(2);
	var abstract_captcha_model_1 = __webpack_require__(6);
	var uid = __webpack_require__(8);
	var picture_model_html_template_1 = __webpack_require__(9);
	var utils_1 = __webpack_require__(10);

	var PictureCaptchaModel = function (_abstract_captcha_mod) {
	    _inherits(PictureCaptchaModel, _abstract_captcha_mod);

	    function PictureCaptchaModel() {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref$captchaPicUrl = _ref.captchaPicUrl,
	            captchaPicUrl = _ref$captchaPicUrl === undefined ? 'https://apps-ws.xoyo.com/passport/captcha' : _ref$captchaPicUrl,
	            _ref$elementId = _ref.elementId,
	            elementId = _ref$elementId === undefined ? PictureCaptchaModel.getRandomElementId() : _ref$elementId;

	        _classCallCheck(this, PictureCaptchaModel);

	        var _this = _possibleConstructorReturn(this, _abstract_captcha_mod.call(this));

	        _this.captchaPicUrl = captchaPicUrl;
	        _this.elementId = elementId;
	        _this.onPicCaptchaClick = _this.onPicCaptchaClick.bind(_this);
	        return _this;
	    }

	    PictureCaptchaModel.getRandomElementId = function getRandomElementId() {
	        return String(uid());
	    };

	    PictureCaptchaModel.prototype.verifyProcess = function verifyProcess() {
	        var _this2 = this;

	        return new Promise(function (resolve) {
	            _this2.resolve = resolve;
	            _this2.open();
	        });
	    };

	    PictureCaptchaModel.prototype.resetProcess = function resetProcess() {
	        if (this.$pictureCaptcha) {
	            this.close();
	            this.$pictureCaptcha.parentNode.removeChild(this.$pictureCaptcha);
	            this.$pictureCaptcha = null;
	        }
	    };

	    PictureCaptchaModel.prototype.onSubmitClick = function onSubmitClick() {
	        var captchaValue = this.$input.value;
	        if (captchaValue) {
	            this.resolve({
	                state: index_1.VerifyRejectState.Success,
	                data: { phrase: captchaValue, tag: this.elementId }
	            });
	            this.close();
	        } else {
	            alert('请填写验证码!');
	        }
	    };

	    PictureCaptchaModel.prototype.onPicCaptchaClick = function onPicCaptchaClick(e) {
	        e.target.src = this.refreshPicCaptchaSrc();
	    };

	    PictureCaptchaModel.prototype.refreshPicCaptchaSrc = function refreshPicCaptchaSrc() {
	        return this.captchaPicUrl + "?tag=" + this.elementId + "&" + +new Date();
	    };

	    PictureCaptchaModel.prototype.onCloseButtonClick = function onCloseButtonClick() {
	        this.resolve({
	            state: index_1.VerifyRejectState.Cancel,
	            data: null
	        });
	        this.close();
	    };

	    PictureCaptchaModel.prototype.open = function open() {
	        if (!this.$pictureCaptcha) {
	            this.$pictureCaptcha = this.renderPictureCaptcha();
	        }
	        this.$pictureCaptcha.style.display = 'block';
	        document.body.appendChild(this.$pictureCaptcha);
	    };

	    PictureCaptchaModel.prototype.close = function close() {
	        var $pictureCaptcha = this.$pictureCaptcha;

	        if ($pictureCaptcha) {
	            $pictureCaptcha.style.display = 'none';
	        }
	    };

	    PictureCaptchaModel.prototype.renderPictureCaptcha = function renderPictureCaptcha() {
	        var _this3 = this;

	        var div = document.createElement('div');
	        div.innerHTML = picture_model_html_template_1["default"];
	        var result = div.firstChild;
	        var $close = utils_1.getElementsByClassName('xsj-pic-captcha-close', result)[0];
	        this.$input = utils_1.getElementsByClassName('xsj-pic-captcha-input', result)[0];
	        var $captchaImg = utils_1.getElementsByClassName('xsj-pic-captcha-img', result)[0];
	        $captchaImg.src = this.refreshPicCaptchaSrc();
	        utils_1.addEventListener($captchaImg, 'click', this.onPicCaptchaClick);
	        var $submitBtn = utils_1.getElementsByClassName('xsj-pic-captcha-btn', result)[0];
	        utils_1.addEventListener($close, 'click', function () {
	            return _this3.onCloseButtonClick();
	        });
	        utils_1.addEventListener($captchaImg, 'click', this.onPicCaptchaClick);
	        utils_1.addEventListener($submitBtn, 'click', function () {
	            return _this3.onSubmitClick();
	        });
	        utils_1.addEventListener(this.$input, 'keyup', function (event) {
	            event.preventDefault();
	            if (event.keyCode === 13) {
	                $submitBtn.click();
	            }
	        });
	        return result;
	    };

	    return PictureCaptchaModel;
	}(abstract_captcha_model_1["default"]);

	exports["default"] = PictureCaptchaModel;
	//# sourceMappingURL=picture-captcha-model.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/**
	 * Export `uid`
	 */

	module.exports = uid;

	/**
	 * Create a `uid`
	 *
	 * @param {String} len
	 * @return {String} uid
	 */

	function uid(len) {
	  len = len || 7;
	  return Math.random().toString(35).substr(2, len);
	}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var templateString = "<div class=\"xsj-pic-captcha\"><div class=\"xsj-pic-captcha-sliver\" style=\"background: #808080; background-color: rgba(0, 0, 0, 0.5); bottom: 0; left: 0; position: absolute; right: 0; top: 0; z-index: 9000;\"></div><div class=\"xsj-pic-captcha-box\" style=\"background: #fff; left: 50%; margin-left: -160px; padding: 20px; position: absolute; top: 50%; width: 300px; z-index: 9999;\"><img class=\"xsj-pic-captcha-close\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAe0lEQVQ4T7WT0Q2AMAhE7zZyFEdwNEdwFDfCkFRjEVqaxv60TeABB1BETgAbSb3TR0QWADvL4wCwZiGVj4YcgVhb3jlnIJ7NA+hlEgWoABGkld0HYCGlxFBkF2Ag+g079A/gXfNwCZ5gaRFbht02Tg1Sxjma2Pllml3nC2ohigWIYK4xAAAAAElFTkSuQmCC\" style=\"cursor: pointer; font-size: 12px; position: absolute; right: -20px; top: 0;\"><div class=\"xsj-pic-captcha-wrap\" style=\"overflow: hidden; width: 100%;\"><input class=\"xsj-pic-captcha-input\" placeholder=\"&#x8BF7;&#x8F93;&#x5165;&#x9A8C;&#x8BC1;&#x7801;\" style=\"-moz-border-radius: 4px; -moz-box-sizing: content-box; -ms-border-radius: 4px; -o-border-radius: 4px; -webkit-border-radius: 4px; -webkit-box-sizing: content-box; background-color: #fff; border: 1px solid #e6e6e6; border-radius: 4px; box-sizing: content-box; color: #333; float: left; font-size: 14px; height: 48px; line-height: 48px !important; padding: 0 8px; vertical-align: middle; width: 164px;\"> <img class=\"xsj-pic-captcha-img\" style=\"-moz-box-sizing: content-box; -webkit-box-sizing: content-box; box-sizing: content-box; cursor: pointer; float: right; height: 48px; vertical-align: middle; width: 104px;\"></div><button class=\"xsj-pic-captcha-btn\" style=\"background: #1890ff; border: 1px #1890ff solid; border-radius: 5px; color: #fff; cursor: pointer; display: block; font-size: 16px; height: 44px; margin-top: 10px; width: 100%;\">\u786E\u8BA4</button></div></div>";

	exports["default"] = templateString;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	
	Object.defineProperty(exports, "__esModule", { value: true });
	function addEventListener(ele, event, fn) {
	    if (ele.addEventListener) {
	        ele.addEventListener(event, fn, false);
	    } else {
	        ele.attachEvent("on" + event, fn.bind(ele));
	    }
	}
	exports.addEventListener = addEventListener;
	function removeEventListener(ele, event, fn) {
	    if (ele.removeEventListener) {
	        ele.removeEventListener(event, fn, false);
	    } else {
	        ele.detachEvent("on" + event, fn.bind(ele));
	    }
	}
	exports.removeEventListener = removeEventListener;
	exports.addEventListenerOnce = function () {
	    var isFirst = [];
	    return function (ele, event, fn) {
	        var eleArray = isFirst.filter(function (item) {
	            return item === ele;
	        });
	        if (eleArray.length) return false;
	        if (ele.addEventListener) {
	            ele.addEventListener(event, fn, false);
	        } else {
	            ele.attachEvent("on" + event, fn.bind(ele));
	        }
	        isFirst.push(ele);
	    };
	}();
	function getElementsByClassName(cls, context) {
	    context = context || document;
	    if (context.getElementsByClassName) {
	        return context.getElementsByClassName(cls);
	    }
	    var result = [];
	    var arr = context.getElementsByTagName('*');
	    var re = new RegExp("\\b" + cls + "\\b"); //""前面必须加上/
	    for (var i = 0; i < arr.length; i++) {
	        if (re.test(arr[i].className)) {
	            result.push(arr[i]);
	        }
	    }
	    return result;
	}
	exports.getElementsByClassName = getElementsByClassName;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	Object.defineProperty(exports, "__esModule", { value: true });

	var GeeTestRejectError = function GeeTestRejectError($state, $data) {
	    _classCallCheck(this, GeeTestRejectError);

	    this.$state = $state;
	    this.$data = $data;
	};

	exports["default"] = GeeTestRejectError;
	//# sourceMappingURL=gee-test-reject-error.js.map

/***/ })
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@xfe/captcha-handler/dist/captcha-handler.js
// module id = 1021
// module chunks = 0 1 2